import React, { useEffect } from 'react';
import { resolverRotaInicial } from '../../../shared/rota-inicial';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  setAccessToken,
  setRefreshToken,
  setUserType,
  setCodigoVoluntario,
  setMustChangePassword,
} from '../reducer';
import OrangeSpinner from '../../../components/loading/OrangeSpinner';
import { decodeJwtPayload } from '../../../utils/jwt';

const GoogleCallback: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get('token');
    const refreshToken = searchParams.get('refreshToken');

    if (!token) {
      navigate('/login?error=google_auth_failed', { replace: true });
      return;
    }

    const payload = decodeJwtPayload(token);
    if (!payload) {
      navigate('/login?error=token_decode_failed', { replace: true });
      return;
    }

    dispatch(setAccessToken(token));
    dispatch(setUserType(payload.userType ?? null));
    dispatch(setCodigoVoluntario(payload.codigoVoluntario ?? null));
    dispatch(setMustChangePassword(Boolean(payload.mustChangePassword)));

    localStorage.setItem('authToken', token);
    sessionStorage.removeItem('passwordChangeDeferred');
    if (refreshToken) {
      dispatch(setRefreshToken(refreshToken));
      localStorage.setItem('refreshToken', refreshToken);
    }

    // at-65 (BUG-V69): os dois primeiros destinos eram strings escritas à mão
    // (`/contac/dashboard` e `/contac/resultado-por-placa`) que **não existem** no
    // `App.tsx` — as rotas reais são `/contac-dashboard` e `/resultado-por-placa`.
    // Login por Google de CONSULTOR/REGIONAL/CONTAC/RELACIONAMENTO caía em rota inválida.
    // Passam a vir das mesmas constantes que o `login.tsx` usa, que é a fonte única.
    // at-81: o mesmo resolvedor do login e do RedirectByRole. A lição do BUG-V69 virou
    // estrutura — não existe mais lugar onde escrever destino de login à mão.
    navigate(resolverRotaInicial(payload), { replace: true });
  }, [dispatch, navigate, searchParams]);

  return <OrangeSpinner />;
};

export default GoogleCallback;
